export default __webpack_public_path__ + "static/media/ItemsLocationOrangeIcon.512644d5.png";